import React, { useEffect, useState, lazy, Suspense } from "react";
import { useApplicationState, updateApplicationTitle } from '../../utilities/applicationState';
import Partners from './partnersOneUX';
import './contactManagement.scss';
import { SdfTab, SdfTabGroup } from '@synerg/react-components';
const ADPAdvisors = lazy(() => import("./adpAdvisors/adpAdvisors"));

export default function ContactManagement() {
	const [, dispatch] = useApplicationState();
	const [selectedTab, setSelectedTab] = useState('partners');

	const onSelectedTab = (event) => {
		if (event.detail.value) {
			setSelectedTab(event.detail.value);
		}
	};

	useEffect(() => {
		const title = 'PARTNER ORGS';
		dispatch(updateApplicationTitle(title));
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<div className="partner-project-list-container mx-24 my-10">
			<div slot="breadcrumb" className="mb-5" onClick={() => { }}>
				Partner orgs <span>/</span>
			</div>
			<span slot="title" className="text-heading-07 font-black">Partner orgs</span>
			<SdfTabGroup className="mt-5" onSdfChange={($event) => onSelectedTab($event)} >
				<SdfTab value="partners" active={selectedTab === "partners"}>Partner list</SdfTab>
				<SdfTab value="advisors" active={selectedTab === "advisors"}>ADP advisors</SdfTab>
			</SdfTabGroup>
			{selectedTab === "partners" && <Partners />}
			{selectedTab === "advisors" && (
				<Suspense fallback={<div>Loading...</div>}>
					<ADPAdvisors />
				</Suspense>
			)}


		</div>
	);
}

